import { openSubOrderModal } from '../../../State/subOrderModal'

export default () => (dispatch) => {

  dispatch(openSubOrderModal())

}
